import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-05/lesson-15/task-01";

const task: Slide = {
  titleHtml:
    "The following photos show real examples of architectural elements designed to interact<br>with the room acoustics. Based on what you have learned so far, can you tell how<br>each of these elements behaves from an acoustic point of view?",
  description: "Drag and drop pictures.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
